import { Filtros } from "../types/Filtros";
import DashboardGateway from "./interfaces/DashboardGateway";

export default class DashboardGatewayFake implements DashboardGateway {
    async getLastSixMonthsData(filtros: Filtros): Promise<null> {
        return null;
    }

}